// extracted by mini-css-extract-plugin
export default {"disabled":"MenuItemPriceBlock_disabled__Nzagb"};